import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { FormControl, Button } from 'react-bootstrap';
import { Product } from '@views/components/product/Product';
import ProductAction from '@views/components/product/ProductAction';

export interface Props {
  quantity: number;
  handleUpdateItem: (quantity: number, cb?: () => void) => void;
  disabled?: boolean;
}

export const Action: FunctionComponent<Props> = ({
  quantity: quantityProp,
  handleUpdateItem,
  disabled,
}) => {
  const [changed, setChanged] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<number>(quantityProp);

  const increaseQuantity = useCallback(
    (event: any) => {
      setQuantity(quantity + 1);
      setChanged(true);
    },
    [quantity]
  );

  const decreaseQuantity = useCallback(
    (event: any) => {
      let newValue = quantity - 1;
      if (newValue < 1) {
        newValue = 1;
      }

      setQuantity(newValue);
      setChanged(true);
    },
    [quantity]
  );

  const handleChange = (event: any) => {
    const value = parseInt(event.target.value);
    setQuantity(isNaN(value) || value <= 0 ? 1 : value);
    setChanged(true);

    event.preventDefault();
    return false;
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (changed) {
        handleUpdateItem(quantity, () => {
          setChanged(false);
        });
      }
    }, 1500);
    return () => {
      clearTimeout(timeout);
    };
  }, [quantity, changed]);

  return (
    // <form>
    <Product>
      <ProductAction>
        <div className="input-number product__quantity">
          <Button
            type="button"
            className="input-number__sub"
            disabled={disabled}
            onClick={decreaseQuantity}
          />
          <FormControl
            type="number"
            name="quantity"
            className="input-number__input"
            value={`${quantity || 1}`}
            onChange={handleChange}
            disabled={disabled}
          />
          <Button
            type="button"
            className="input-number__add"
            disabled={disabled}
            onClick={increaseQuantity}
          />
        </div>
      </ProductAction>
    </Product>
    // </form>
  );
};

export default Action;
